export enum FeaturesEnum {
  SINGLE_SIGN_ON = 'single-sign-on',
  CENTRAL_AUDIT_LOGS = 'central-audit-logs',
  PERFORMANCE_CENTER = 'performance-center',
  VIDEO_PROCESSING = 'video-processing',
  MEDIA_LIBRARY_BACKUP = 'media-library-backup',
  MEDIA_LIBRARY_STORAGE = 'media-library-storage',
  CUSTOM_CDN = 'custom-cdn',
  SECURITY = 'security',
  EXTENSIONS = 'extensions',
  USER_MANAGEMENT = 'user-management',
  CUSTOM_CNAME = 'custom-cname',
  SLA_CHAT_SUPPORT = 'sla-support',
  ACL_AND_COLLECTIONS = 'access-control-and-media-collections',
  DRAFT_ASSETS = 'draft-assets',
  PUBLIC_LINKS = 'public-links',
  SEMANTIC_SEARCH = 'semantic-search',
  PATH_POLICY = 'path-policy',
  AUTO_AVIF = 'auto-avif',
  ORIGINAL_FILE_CACHE = 'original-file-cache',
}

export const DAMFeaturesEnum = [FeaturesEnum.MEDIA_LIBRARY_STORAGE, FeaturesEnum.EXTENSIONS, FeaturesEnum.ACL_AND_COLLECTIONS, FeaturesEnum.DRAFT_ASSETS, FeaturesEnum.PUBLIC_LINKS, FeaturesEnum.MEDIA_LIBRARY_BACKUP, FeaturesEnum.CENTRAL_AUDIT_LOGS, FeaturesEnum.SEMANTIC_SEARCH];

export const OtherFeaturesEnum = [FeaturesEnum.USER_MANAGEMENT, FeaturesEnum.PERFORMANCE_CENTER, FeaturesEnum.CUSTOM_CNAME, FeaturesEnum.SINGLE_SIGN_ON, FeaturesEnum.VIDEO_PROCESSING, FeaturesEnum.CUSTOM_CDN, FeaturesEnum.SECURITY, FeaturesEnum.AUTO_AVIF, FeaturesEnum.ORIGINAL_FILE_CACHE];

export const SupportFeaturesEnum = [FeaturesEnum.SLA_CHAT_SUPPORT];

export const FeatureNameMapping = {
  [FeaturesEnum.SINGLE_SIGN_ON]: 'Single sign on',
  [FeaturesEnum.CENTRAL_AUDIT_LOGS]: 'Central audit logs',
  [FeaturesEnum.PERFORMANCE_CENTER]: 'Performance center',
  [FeaturesEnum.VIDEO_PROCESSING]: 'Video processing',
  [FeaturesEnum.MEDIA_LIBRARY_BACKUP]: 'Media library backup',
  [FeaturesEnum.MEDIA_LIBRARY_STORAGE]: 'Media library storage',
  [FeaturesEnum.CUSTOM_CDN]: 'Custom CDN integration',
  [FeaturesEnum.SECURITY]: 'Advanced security',
  [FeaturesEnum.EXTENSIONS]: 'AI Extensions',
  [FeaturesEnum.USER_MANAGEMENT]: 'User management',
  [FeaturesEnum.CUSTOM_CNAME]: 'Custom domain name',
  [FeaturesEnum.SLA_CHAT_SUPPORT]: 'SLA Support',
  [FeaturesEnum.ACL_AND_COLLECTIONS]: 'Access control and media collections',
  [FeaturesEnum.DRAFT_ASSETS]: 'Draft assets',
  [FeaturesEnum.PUBLIC_LINKS]: 'Public links',
  [FeaturesEnum.SEMANTIC_SEARCH]: 'Visual search',
  [FeaturesEnum.PATH_POLICY]: 'Path policy',
  [FeaturesEnum.AUTO_AVIF]: 'Auto AVIF',
  [FeaturesEnum.ORIGINAL_FILE_CACHE]: 'Original file cache',
}

export const paidPlanDefaultFeatureEnum = [
  FeaturesEnum.VIDEO_PROCESSING,
  FeaturesEnum.MEDIA_LIBRARY_STORAGE,
  FeaturesEnum.EXTENSIONS,
  FeaturesEnum.CUSTOM_CNAME,
  FeaturesEnum.PERFORMANCE_CENTER,
  FeaturesEnum.USER_MANAGEMENT,
  FeaturesEnum.SLA_CHAT_SUPPORT,
  FeaturesEnum.MEDIA_LIBRARY_BACKUP,
  FeaturesEnum.CUSTOM_CDN,
  FeaturesEnum.ACL_AND_COLLECTIONS,
]
